import {
  CreateModelState,
  CreateModelAction,
  DashboardState,
  DashboardAction,
  ProgressState,
  ProgressAction,
} from "../types";

// ── CreateModel ────────────────────────────────────────────────────────────────

export const createModelInitialState: CreateModelState = {
  title: "",
  description: "",
  assumption: "",
  assumptions: [],
  selectedFile: null,
  fileUploaded: false,
  isLoading: false,
  loadingMessage: "",
  error: null,
};

export function createModelReducer(
  state: CreateModelState,
  action: CreateModelAction
): CreateModelState {
  switch (action.type) {
    case "SET_TITLE":
      return { ...state, title: action.payload };

    case "SET_DESCRIPTION":
      return { ...state, description: action.payload };

    case "SET_ASSUMPTION_INPUT":
      return { ...state, assumption: action.payload };

    case "ADD_ASSUMPTION":
      if (!state.assumption.trim()) return state;
      return {
        ...state,
        assumptions: [...state.assumptions, state.assumption.trim()],
        assumption: "",
      };

    case "REMOVE_ASSUMPTION":
      return {
        ...state,
        assumptions: state.assumptions.filter((_, i) => i !== action.payload),
      };

    case "SET_FILE":
      return { ...state, selectedFile: action.payload };

    case "SET_FILE_UPLOADED":
      return { ...state, fileUploaded: action.payload };

    case "START_LOADING":
      return {
        ...state,
        isLoading: true,
        loadingMessage: action.payload,
        error: null,
      };

    case "STOP_LOADING":
      return { ...state, isLoading: false, loadingMessage: "" };

    case "SET_ERROR":
      return { ...state, error: action.payload };

    case "RESET":
      return createModelInitialState;

    default:
      return state;
  }
}

// ── Dashboard ──────────────────────────────────────────────────────────────────

export const dashboardInitialState: DashboardState = {
  selectedThreat: null,
};

export function dashboardReducer(
  state: DashboardState,
  action: DashboardAction
): DashboardState {
  switch (action.type) {
    case "SELECT_THREAT":
      return { ...state, selectedThreat: action.payload };

    default:
      return state;
  }
}

// ── ModelingProgress ───────────────────────────────────────────────────────────

export const progressInitialState: ProgressState = {
  revealedCount: 0,
  isComplete: false,
};

export function progressReducer(
  state: ProgressState,
  action: ProgressAction
): ProgressState {
  switch (action.type) {
    case "REVEAL_NEXT":
      return { ...state, revealedCount: state.revealedCount + 1 };

    case "SET_COMPLETE":
      return { ...state, isComplete: true };

    default:
      return state;
  }
}
